<template>
  <aqt-table add @on-add="addData" del @on-del="delData" refresh @on-refresh="refreshData" :pageDate="pageDate" @on-pageChange="refreshData">
    <div slot="table" style="margin-bottom: 10px; display: flex">
      <Input v-model="query.name" search placeholder="姓名" @on-search="refreshData(1)" style="width: 200px; margin-right: 10px"/>
      <Input v-model="query.tel" search placeholder="手机号" @on-search="refreshData(1)" style="width: 200px; margin-right: 10px"/>
    </div>
    <Table border stripe :loading="tableLoading" :columns="columns" @on-selection-change="removeData" :data="data" slot="table"></Table>
    <aqt-sidebar v-model="show" :title="titles" slot="others">
      <component :is="content" :condition="condition" @operationState="operationState"></component>
    </aqt-sidebar>

  </aqt-table>
</template>

<script>
export default {
  components: {
    Operation: resolve => {require(['./Operation.vue'], resolve);},
  },
  data() {
    return {
      tableLoading: false,
      show: false,
      titles: '',
      content: '',
      condition: false,
      pageDate: {
        total: 1,
        current_page: 1,
        per_page: 1,
      },
      data: [],
      columns: [
        {
          type: 'selection',
          width: 80,
          align: 'center'
        },
        {
          title: '姓名',
          minWidth: 100,
          align: 'center',
          key: 'name',
        },
        {
          title: '手机号',
          minWidth: 100,
          align: 'center',
          key: 'tel',
        },
        {
          title: '工作单位',
          minWidth: 100,
          align: 'center',
          key: 'work',
        },
        {
          title: '职称',
          minWidth: 100,
          align: 'center',
          key: 'professional',
        },
        {
          title: '所属院系',
          minWidth: 100,
          align: 'center',
          key: 'academy',
        },
        {
          title: '身份',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            return h('div',params.row.user_type?this.user_typeList[params.row.user_type*1-1]:'')
          }
        },
        {
          title: '状态',
          minWidth: 100,
          align: 'center',
          render: (h,params) => {
            let ss = params.row.status==1?'正常':'禁用'
            let colors = params.row.status==1?'green':'red'
            return h('div',{
              style:{
                color:colors
              }
            },ss)
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.editData (params.row.users_id)
                  }
                }
              }, '修改'),
              h('Poptip', {
                props: {
                  confirm: true,
                  transfer: true,
                  title: '您确定要删除这条数据吗?',
                  type: 'error',
                  size: 'small',
                  placement:'left-end',
                  disabled:this.columsDel
                },
                style: {
                  textAlign: 'left',
                },
                on: {
                  'on-ok': () => {
                    this.del = [params.row.users_id];
                    this.columsDel = true
                    this.delSubmit ();
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    loading:this.columsDel&&this.del.length==1&&this.del[0]==params.row.users_id?true:false
                  }
                }, '删除')
              ]),
            ]);
          }
        }
      ],
      query:{
        library_id:localStorage.getItem('libId'),
        user_type:3,
        username:'',//用户名 用户类型是管理员
        name:'',//姓名 用户类型是编辑/专家/作者
        page:1,
        tel:'',//手机号 用户类型是编辑/专家/作者
      },
      del: [],
      user_typeList:['管理员','编辑','专家','作者'],
      columsDel:false
    }
  },
  methods: {

    /*****************************************************************
     *
     * 添加数据返回状态
     * @param   {data}             状态
     *
     *****************************************************************/
    operationState (data) {
      if (data) this.show = false
      this.refreshData (this.pageDate.current_page)
    },

    /************************************************************
     *
     * 添加数据
     *
     ************************************************************/
    addData () {
      this.condition = false
      this.content = 'Operation'
      this.titles = '添加'
      this.show = true
    },
    /************************************************************
     *
     * 修改数据
     * @param   {index}               id
     *
     ************************************************************/
    editData (id) {
      this.condition = id
      this.content = 'Operation'
      this.titles = '修改'
      this.show = true
    },

    /************************************************************
     *
     * 单条删除
     * @param   {id}               id
     *
     ************************************************************/
    removeData (item) {
      this.del=item.map(e => e.users_id);
    },

    /************************************************************
     *
     * 删除确认
     *
     ************************************************************/
    delData () {
      if(!this.del.length){
        this.$Message.warning('请选择要删除的内容')
        return
      }
      this.$Modal.confirm({
        title: '删除确认',
        closable: true,
        loading: true,
        content: '您确定要删除这些数据吗?',
        onOk: () => {
          this.delSubmit ()
        }
      })
    },

    /************************************************************
     *
     * 删除操作
     *
     ************************************************************/
    delSubmit () {
      let cond = {
        library_id: localStorage.getItem('libId'),
        user_type: 3,
        id:JSON.stringify(this.del)
      }
      this.$httpsencrypt.post('api/contributeweb/v3/users/dels' ,cond).then(val=>{
        this.$Modal.remove ()
        this.refreshData (this.pageDate.current_page)
        this.$Message.success('删除成功!');
        this.del=[]
        this.columsDel = false
      }).catch(err => {
        this.del=[]
        this.columsDel = false
        this.$Modal.remove ()
        this.$Message.error('删除失败!');
      })
    },

    /************************************************************
     *
     * 列表数据
     *
     ************************************************************/
    queryData (index) {
      const _this = this
      _this.query.page = index
      _this.$httpsencrypt.post(`api/contributeweb/v3/users/list`,_this.query)
          .then(val =>{
            _this.data = val.data;
            _this.tableLoading = false;
            _this.pageDate.current_page = val.pages.current_page;
            _this.pageDate.per_page = val.pages.per_page;
            _this.pageDate.total = val.pages.total;
          }).catch(err =>{
        _this.tableLoading=false;
      })
    },

    /************************************************************
     *
     * 刷新
     *
     ************************************************************/
    refreshData (index) {
      this.data = []
      this.tableLoading = true
      this.queryData (index ? index : 1)
    }
  },
  created() {
    this.refreshData ()
  },
};
</script>

<style lang="less" scoped>
</style>
